<template>
    <div>
        <div :class="wrapperClasses">
            <table class="Table Table--striped">
                <thead>
                <tr>
                    <th v-for="(column, index) in columns" :class="columnClasses(index)">{{ column }}</th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="(row, rank) in sortedRows">
                        <tr>
                            <td v-for="(cell, index) in row" :class="columnClasses(index)">
                                <span v-if="isPercentageChangeRow(row) && index != 0" v-html="utilityPosNeg(cell)"></span>
                                <percentage-change-bar v-else-if="isPercentageChangeBarColumn(index)" :change="cell">
                                </percentage-change-bar>
                                <table-expander :data-url="cell" :rank="rank" :name="name" v-else-if="isExpanderColumn(index) && showExpanders"></table-expander>
                                <span v-else-if="isExpanderColumn(index) && !showExpanders"></span>
                                <span v-else v-html="cell"></span>
                            </td>
                        </tr>

                        <template v-if="isExpandable && showExpanders">
                            <tr v-show="false"><td :colspan="columnCount"></td></tr>
                            <table-expansion :rank="rank" :name="name" :colspan="columnCount"></table-expansion>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>

        <a href="#"
           class="Button Utility--margin-top-10"
           v-if="limitRows && hasMoreThanTenRows"
           @click.prevent="toggleWrapper"
        >
            {{ toggleWrapperText }}
        </a>
    </div>

</template>

<script>
    import utlities from '../../mixins/utilities';

    export default {
        data() {
            return {
                wrapperClosed: true,
            }
        },

        props: {
            name: {
                type: String,
                default: ''
            },

            columns: {
                type: Array,
            },

            columnFormats: {
                type: Array
            },

            rows: {
                type: Array
            },

            limitRows: {
                type: Boolean,
                default: true,
            },

            sortBy: {
                type: Number,
                default: -1
            },

            sortByDirection: {
                type: String,
                default: 'asc',
            },

            showExpanders: {
                type: Boolean,
                default: true,
            }
        },

        computed: {
            wrapperClasses() {
                return {
                    'TableResponsive': true,
                    'TableResponsive--max-10-rows-closed': this.limitRows && this.wrapperClosed
                }
            },

            toggleWrapperText() {
                if (this.wrapperClosed) {
                    return 'Show More';
                }

                return 'Show Less';
            },

            hasMoreThanTenRows() {
                return this.rows.length > 10;
            },

            sortedRows() {
                if (this.sortBy === -1) return this.rows;

                let rows = _.sortBy(this.rows, function (row) {
                    return row[this.sortBy];
                }.bind(this));

                return this.sortByDirection == 'asc' ? rows : _.reverse(rows);
            },

            isExpandable() {
                return _.includes(this.columnFormats, 'expander');
            },

            columnCount() {
                return this.columnFormats.length;
            }
        },

        methods: {
            columnClasses(index) {
                if (this.columnFormats[index] === '') return;

                return 'Table__cell--' + this.columnFormats[index];
            },

            isPercentageChangeRow(row) {
                return row[0] == '% Change';
            },

            isPercentageChangeBarColumn(index) {
                return this.columnFormats[index] == 'percentage-change-bar';
            },

            isExpanderColumn(index) {
                return this.columnFormats[index] == 'expander';
            },

            toggleWrapper() {
                this.wrapperClosed = ! this.wrapperClosed;
            }
        },

        mixins: [utlities],
    }
</script>